import { Link } from "react-router-dom";
import { Phone, Mail, Facebook } from "lucide-react";

export const SiteFooter = () => (
  <footer className="on-dark bg-[#141210] text-[#BDB3A5] print:hidden" data-testid="site-footer">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
      <div>
        <div className="flex items-center gap-3">
          <img src="/images/bourbon-king-logo.png" alt="" className="h-11 w-11 rounded-full" />
          <p className="font-display text-2xl text-white">The Bourbon <em className="text-[#D9B864]">King</em></p>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed">Official home of Toby "The Bourbon King™" Curtsinger.</p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="eyebrow mb-3">Contact</p>
        <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#D9B864]" /><a href="tel:+15027830430" className="hover:text-[#D9B864]" data-testid="footer-phone-link">(502) 783-0430</a></p>
        <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#D9B864]" /><a href="mailto:bourbonkingevents@gmail.com" className="hover:text-[#D9B864]" data-testid="footer-email-link">bourbonkingevents@gmail.com</a></p>
        <p className="flex items-center gap-2"><Facebook className="h-4 w-4 text-[#D9B864]" /><a href="https://www.facebook.com/p/Bourbon-King-Enterprises-LLC-61562851261656/" target="_blank" rel="noreferrer" className="hover:text-[#D9B864]" data-testid="footer-facebook-link">Bourbon King Enterprises on Facebook</a></p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="eyebrow mb-3">Explore</p>
        <p><Link to="/" className="hover:text-[#D9B864]" data-testid="footer-events-link">All events</Link></p>
        <p><Link to="/the-bourbon-king" className="hover:text-[#D9B864]" data-testid="footer-story-link">The story</Link></p>
        <p><Link to="/bourbon-clubs" className="hover:text-[#D9B864]" data-testid="footer-clubs-link">Book Toby for your club</Link></p>
        <p><Link to="/booking" className="hover:text-[#D9B864]" data-testid="footer-find-booking-link">Find my booking</Link></p>
        <p><Link to="/admin" className="hover:text-[#D9B864]" data-testid="footer-admin-link">Host login</Link></p>
      </div>
    </div>
    <div className="mx-auto max-w-6xl border-t border-white/10 px-5 py-6 text-xs leading-relaxed text-[#8A8076] sm:px-8">
      <p>Bourbon King™ Enterprises, LLC is not affiliated with, nor sponsored and/or endorsed by, Buffalo Trace Distillery or Sazerac Brands.</p>
      <p className="mt-2">© {new Date().getFullYear()} Bourbon King™ Enterprises, LLC. Guests must be 21+.</p>
    </div>
  </footer>
);
